import React from 'react';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
import { Instagram, Facebook, MessageCircle, Mail, Phone } from 'lucide-react';
export function Footer() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].footer;
  return <footer className="bg-mf-black text-white pt-16 pb-8 border-t-4 border-mf-red" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12" data-id="element-136">
          {/* Brand & Info */}
          <div className="md:col-span-5" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/87bxoPCzmrJpV9TJfPPsjR/IMG_4659.jpg" alt="Move Fighters Logo" className="h-16 w-auto object-contain rounded mb-6" data-id="element-138" />
            <p className="text-gray-400 mb-6 max-w-md font-medium" data-id="element-139">{text.hq}</p>
            <div className="space-y-3" data-id="element-140">
              <a href="mailto:movefighters@gmail.com" className="flex items-center text-gray-300 hover:text-mf-yellow transition-colors" data-id="element-141">
                <Mail size={20} className="mr-3 text-mf-red" data-id="element-142" />
                movefighters@gmail.com
              </a>
              <a href="tel:+18005550199" className="flex items-center text-gray-300 hover:text-mf-yellow transition-colors" data-id="element-143">
                <Phone size={20} className="mr-3 text-mf-red" data-id="element-144" />
                1-800-FIGHTERS
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-4" data-id="element-145">
            <h4 className="text-xl font-condensed font-bold uppercase tracking-wider mb-6 text-white" data-id="element-146">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-147">
              <li data-id="element-148">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-149">
                  {text.privacy}
                </a>
              </li>
              <li data-id="element-150">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-151">
                  {text.terms}
                </a>
              </li>
              <li data-id="element-152">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-153">
                  {text.refund}
                </a>
              </li>
              <li data-id="element-154">
                <a href="#" className="text-mf-yellow hover:text-white transition-colors font-bold" data-id="element-155">
                  {text.careers}
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="md:col-span-3" data-id="element-156">
            <h4 className="text-xl font-condensed font-bold uppercase tracking-wider mb-6 text-white" data-id="element-157">
              Join The Squad
            </h4>
            <div className="flex space-x-4" data-id="element-158">
              <a href="#" className="bg-mf-darkgray p-3 rounded-full hover:bg-mf-red transition-colors" data-id="element-159">
                <Instagram size={24} data-id="element-160" />
              </a>
              <a href="#" className="bg-mf-darkgray p-3 rounded-full hover:bg-mf-red transition-colors" data-id="element-161">
                <Facebook size={24} data-id="element-162" />
              </a>
              <a href="#" className="bg-mf-darkgray p-3 rounded-full hover:bg-mf-red transition-colors" data-id="element-163">
                <MessageCircle size={24} data-id="element-164" /> {/* TikTok placeholder */}
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-165">
          <p className="text-gray-500 text-sm text-center md:text-left mb-4 md:mb-0" data-id="element-166">
            {text.rights}
          </p>
          <div className="text-gray-600 text-sm font-condensed font-bold tracking-widest uppercase" data-id="element-167">
            Built for Conversion
          </div>
        </div>
      </div>
    </footer>;
}